// onbording avatar
import onBoardingavatar1 from "assets/svg/OnboardingprofileImgAvatar.svg";
import onBoardingavatar2 from "assets/svg/onboardingAvatar2.svg";
import onBoardingavatar3 from "assets/svg/onBoardingAvatar3.svg";
import onBoardingavatar4 from "assets/svg/OnboardingprofileImgAvatar.svg";
// import onBoardingavatar5 from "assets/svg/poll-avatar5.svg";

interface Avatar {
  [key: string]: string | undefined;
}

const OnboardingAvatars: Avatar = {
  "onBoardingAvatar-5": "imagePicked",
  "onBoardingAvatar-1": onBoardingavatar1,
  "onBoardingAvatar-2": onBoardingavatar2,
  "onBoardingAvatar-3": onBoardingavatar3,
  "onBoardingAvatar-4": onBoardingavatar4,
};

export default OnboardingAvatars;
